"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesMode = void 0;
var NotesMode;
(function (NotesMode) {
    NotesMode[NotesMode["Create"] = 0] = "Create";
    NotesMode[NotesMode["Edit"] = 1] = "Edit";
    NotesMode[NotesMode["View"] = 2] = "View";
})(NotesMode = exports.NotesMode || (exports.NotesMode = {}));
